import React from 'react';
import { Text } from './Text';

interface DotsLoaderProps {
  text: string;
}

export const DotsLoader: React.FC<DotsLoaderProps> = ({ text }) => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', gap: '4px' }}>
    <style>{`
      @keyframes ellipsis-dot {
        0%, 100% { opacity: 0; }
        50% { opacity: 1; }
      }
    `}</style>
    <Text variant='body2'>{text}</Text>
    <div style={{ display: 'flex', alignItems: 'baseline', gap: '2px' }}>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          style={{
            display: 'inline-block',
            width: '3px',
            height: '3px',
            borderRadius: '50%',
            backgroundColor: 'currentColor',
            animation: `ellipsis-dot 1.2s ease-in-out ${i * 0.2}s infinite`
          }}
        />
      ))}
    </div>
  </div>
);
